/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Datastore} from '../common/datastore';
import {DatastoreItem, Datastores} from '../services/datastores';
import {Content} from '../common/content';

interface JobState {
  isLoading: boolean;
  items: ReadonlyArray<DatastoreItem>;
}

export class Job extends React.Component<{}, JobState> {
  readonly #symbol = Symbol('Job');

  constructor(props: {}, state: JobState) {
    super(props, state);
    this.state = {isLoading: true, items: []};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.jobItems.addObserver(this.#symbol, (value) => {
      this.setState({isLoading: value === null, items: value === null ? [] : value});
    });
  }

  override componentWillUnmount() {
    Datastores.jobItems.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  #reloadData(): void {
    this.setState({isLoading: true});
    Datastores.reloadDatastore();
  }

  override render() {
    return (
      <Content
        section='Datastore: Job'
        isLoading={this.state.isLoading}
      >
        <Datastore
          type='Job'
          items={this.state.items}
          reloadCommand={() => this.#reloadData()}
        />
      </Content>
    );
  }
}
